import { CellPlugin } from '@react-page/editor';
import RankinSearchResults, {
    DEFENDANT_NAME_LABEL, CITATION_NUMBER_LABEL, ISSUE_DATE_LABEL, DESCRIPTION_LABEL, BALANCE_DUE_LABEL,
    PAYMENT_OPTIONS_LABEL, MINIMUM_PARTIAL_PAYMENT_AMOUNT, MINIMUM_PAYMENT_TEXT, MINIMUM_PAYMENT_ERROR_TEXT, HEADER_BACKGROUND_COLOR, HEADER_PADDING, MARGIN, PADDING,
    OVERLAY_TEXT, OVERLAY_BACKGROUND, OVERLAY_TEXT_COLOR, OVERLAY_ICON_COLOR, OBSERVES_WEEKENDS, DURATION_OF_PENDING_HOURS,
    NO_MATCH_FOUND_TEXT
} from './components/RankinSearchResults';

type Data = {
    title: string,
    defendantName: string,
    citationNumber: string,
    issueDate: string,
    description: string,
    balanceDue: string,
    paymentOptions: string,
    minimumPartialPaymentAmount: number,
    minimumPaymentText: string,
    minimumPaymentErrorText: string,
    observesWeekends: boolean,
    durationOfPendingHours: number,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    noMatchFoundText: string,
    headerBackgroundColor: string,
    headerPadding: string,
    margin: string,
    padding: string,
}

const RankinSearchResultsPlugin: CellPlugin<Data> = {
    Renderer: ({ data }) => (
        <RankinSearchResults
            defendantNameLabel={data.defendantName}
            citationNumberLabel={data.citationNumber}
            issueDateLabel={data.issueDate}
            descriptionLabel={data.description}
            balanceDueLabel={data.balanceDue}
            paymentOptionsLabel={data.paymentOptions}
            minimumPartialPaymentAmount={data.minimumPartialPaymentAmount}
            minimumPaymentText={data.minimumPaymentText}
            minimumPaymentErrorText={data.minimumPaymentErrorText}
            observesWeekends={data.observesWeekends}
            durationOfPendingHours={data.durationOfPendingHours}
            overlayText={data.overlayText}
            overlayBackground={data.overlayBackground}
            overlayTextColor={data.overlayTextColor}
            overlayIconColor={data.overlayIconColor}
            noMatchFoundText={data.noMatchFoundText}
            margin={data.margin}
            padding={data.padding}
            headerBackgroundColor={data.headerBackgroundColor}
            headerPadding={data.headerPadding}
        />
    ),
    id: 'rankinResultsPlugin',
    title: 'Rankin Search Results',
    description: 'Rankin County citation search results',
    version: 1,
    controls: [
        {
            title: 'Labels',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        defendantName: {
                            type: 'string',
                            default: DEFENDANT_NAME_LABEL,
                        },
                        citationNumber: {
                            type: 'string',
                            default: CITATION_NUMBER_LABEL,
                        },
                        issueDate: {
                            type: 'string',
                            default: ISSUE_DATE_LABEL,
                        },
                        description: {
                            type: 'string',
                            default: DESCRIPTION_LABEL,
                        },
                        balanceDue: {
                            type: 'string',
                            default: BALANCE_DUE_LABEL,
                        },
                        paymentOptions: {
                            type: 'string',
                            default: PAYMENT_OPTIONS_LABEL,
                        },
                        noMatchFoundText: {
                            type: 'string',
                            default: NO_MATCH_FOUND_TEXT,
                        },
                        observesWeekends: {
                            type: 'boolean',
                            default: OBSERVES_WEEKENDS
                        },
                        durationOfPendingHours: {
                            type: 'number',
                            default: DURATION_OF_PENDING_HOURS
                        },
                        overlayText: {
                            type: 'string',
                            default: OVERLAY_TEXT
                        },
                        overlayBackground: {
                            type: 'string',
                            default: OVERLAY_BACKGROUND
                        },
                        overlayTextColor: {
                            type: 'string',
                            default: OVERLAY_TEXT_COLOR
                        },
                        overlayIconColor: {
                            type: 'string',
                            default: OVERLAY_ICON_COLOR
                        }
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Payment Rules',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        minimumPartialPaymentAmount: {
                            type: 'number',
                            title: 'Minimum partial payment amount ($)',
                            default: MINIMUM_PARTIAL_PAYMENT_AMOUNT
                        },
                        minimumPaymentText: {
                            type: 'string',
                            title: 'Minimum payment text ({amount} = minimum)',
                            default: MINIMUM_PAYMENT_TEXT
                        },
                        minimumPaymentErrorText: {
                            type: 'string',
                            title: 'Minimum payment error text ({amount} = minimum)',
                            default: MINIMUM_PAYMENT_ERROR_TEXT
                        },
                    },
                    required: [],
                },
            },
        },
        {
            title: 'Styles',
            controls: {
                type: 'autoform',
                schema: {
                    properties: {
                        margin: {
                            type: 'string',
                            default: MARGIN,
                        },
                        padding: {
                            type: 'string',
                            default: PADDING,
                        },
                        headerBackgroundColor: {
                            type: 'string',
                            default: HEADER_BACKGROUND_COLOR,
                        },
                        headerPadding: {
                            type: 'string',
                            default: HEADER_PADDING,
                        }
                    },
                    required: [],
                },
            },
        },
    ],
};

export default RankinSearchResultsPlugin;
